<template>
  <div class="carousel-banner" v-ga-section-view data-section-number="1" data-section-name="Hero Banner">
    <div class="carousel-banner-placeholder">
      <transition name="fade">
        <div class="carousel-banner-frame" v-if="homeStore.bannerCarousel.Children.length > 0">
          <swiper
            :navigation="mobile ? false : { prevEl: '.swiper-button-prev', nextEl: '.swiper-button-next' }"
            :pagination="{ clickable: true }"
            :modules="[Pagination, Navigation, Autoplay]"
            :autoplay="{
              delay: homeStore.bannerCarousel.rotationTime * 1000,
              pauseOnMouseEnter: true,
              disableOnInteraction: false,
            }"
            :loop="true"
            class="swiper-style-v1 inner"
            v-ga-swiper-dot
          >
            <swiper-slide v-for="(one, index) in homeStore.bannerCarousel.Children" :key="one.image">
              <a
                :href="one.link"
                :target="one.openInNewWindow ? '_blank' : ''"
                v-ga-event="{
                  interaction: 'link_click',
                  sectionContent: one.name,
                }"
              >
                <img
                  :fetchpriority="`${index == 0 ? 'high' : 'low'}`"
                  :src="mobile && one.imageMobile ? one.imageMobile : one.image"
                  :rel="`${index == 0 ? 'preload' : ''}`"
                  loading="eager"
                />
              </a>
            </swiper-slide>
            <template v-if="!mobile">
              <div class="swiper-button-prev">
                <i-local-home-banner-arrow
                  v-ga-event="{
                    interaction: 'carousel_click',
                    sectionContent: 'Left Arrow',
                  }"
                />
              </div>
              <div class="swiper-button-next">
                <i-local-home-banner-arrow
                  v-ga-event="{
                    interaction: 'carousel_click',
                    sectionContent: 'Right Arrow',
                  }"
                />
              </div>
            </template>
          </swiper>
        </div>
      </transition>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useHomeContentsStore } from '@/store/home/HomeContent'
import 'swiper/css/pagination'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

const { mobile } = useDisplay()
const homeStore = useHomeContentsStore()
</script>
<style lang="scss" scoped>
img {
  display: block; // to eliminate a image bottom gap
}

// actual image ratio should be 1580/712
.carousel-banner {
  background-color: #73cafe;
  text-align: center;
  &-placeholder {
    display: inline-block;
    aspect-ratio: 1600/732;
    max-width: 1600px;
    width: 100%;
  }
  &-frame {
    background: #d39f77;
    width: 100%;
    margin: 0 auto;
    max-width: 1600px;
    padding: 10px;
    color: #763552; // color for navigation buttons
    .inner {
      border-radius: 10px;
      width: 100%;
      background-color: #2d302d;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  :deep(.swiper) {
    .swiper-pagination {
      bottom: 15px;
    }
  }
}

@media #{$tablet} {
  .carousel-banner {
    padding: 0;
    .inner {
      border-radius: 0;
    }

    :deep(.swiper) {
      .swiper-pagination {
        bottom: 10px;
      }
    }
  }
}

@media #{$mobile} {
  .carousel-banner {
    aspect-ratio: 600/878;
    :deep(.swiper) {
      .swiper-pagination {
        bottom: 20px;
      }
    }
  }
}
</style>
